import React from 'react'
import './fairnessModal.scss'

const FairnessModal = (provableFairResult) => {
  const mines = [...(provableFairResult?.mines || [])]
  const firstMine = mines?.sort((a, b) => a - b)?.[0]

  return (
    <div className='game-modal-wrapper text-white p-2 p-lg-3 mh-auto p-2'>
      {
        firstMine && (
          <>
            <span> Result accident lane :</span>
            <div className='bb-cross-fairness-result d-flex justify-content-center align-items-center pb-1 pe-1 mx-auto'>
              {firstMine}
            </div>
          </>
        )
      }
    </div>
  )
}

export default FairnessModal
